import { X, Check } from "lucide-react";

function GetCheckCross({ checkVal }) {
  return (
    <>
      {checkVal !== null ? (
        checkVal ? (
          <Check color="green" className="mx-auto" strokeWidth={2.5} />
        ) : (
          <X color="red" className="mx-auto" strokeWidth={2.5} />
        )
      ) : (
        "-"
      )}
    </>
  );
}

export default GetCheckCross;
